export default __webpack_public_path__ + "static/pro@2x-4ae4c8f617519b1381007cd466861c53.jpg";